import { GiftSubmissionBodyDtoFrequency } from '@portal-middleware/hooks';
import { formatOrdinal } from '@vestwell-frontend/helpers';
import { FormDropdown, FormDropdownProps } from '@vestwell-frontend/ui';

import React, { useMemo } from 'react';

type DayOfMonthFormDropdownProps = Omit<FormDropdownProps, 'options'> & {
  options?: FormDropdownProps['options'];
  frequency?: GiftSubmissionBodyDtoFrequency;
  currentMonth?: number;
};

const generateDaysOfMonth = (month: number): number[] => {
  const daysInMonth = new Date(new Date().getFullYear(), month, 0).getDate();
  return Array.from({ length: daysInMonth }, (_, i) => i + 1);
};

const DayOfMonthFormDropdown: React.FC<DayOfMonthFormDropdownProps> = props => {
  const daysOfTheMonthPresets = useMemo(
    () =>
      props.frequency === GiftSubmissionBodyDtoFrequency.yearly
        ? generateDaysOfMonth(props.currentMonth)
        : Array.from({ length: 28 }, (_, i) => i + 1),
    [props.currentMonth, props.frequency]
  );

  const daysOfMonthOptions = useMemo(
    () =>
      daysOfTheMonthPresets.map(day => ({
        label: `${formatOrdinal(day)}`,
        value: `${day}`
      })),
    [daysOfTheMonthPresets]
  );

  return <FormDropdown {...props} options={daysOfMonthOptions} />;
};

export default DayOfMonthFormDropdown;
